export default __webpack_public_path__ + "static/media/icon_filtrar.31653ba0.svg";